import { NavLink } from 'react-router-dom'
import styles from './Navigation.module.css'

function Navigation() {
  return (
    <nav className={styles.nav}>
      <NavLink
        to="/"
        className={({ isActive }) =>
          isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
        }
      >
        <span className={styles.icon}>✨</span>
        <span>Daily Quote</span>
      </NavLink>
      <NavLink
        to="/quotes"
        className={({ isActive }) =>
          isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
        }
      >
        <span className={styles.icon}>📝</span>
        <span>Manage Quotes</span>
      </NavLink>
    </nav>
  )
}

export default Navigation
